<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form
          :model="queryParams"
          :rules="queryParamsRules"
          ref="queryParamsRefs"
          label-width="110px"
          class="demo-form-inline"
        >
          <div class="add-basic-information">
            <div class="add-title">
              <span class="bold"></span>
              <span class="basic">基本信息</span>
            </div>
            <div>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="品类：" prop="pcId">
                      <el-cascader
                        v-model="queryParams.pcId"
                        :options="proClassList"
                        filterable
                        @change="handleChange"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="品牌：" prop="brandId">
                      <el-select
                        v-model="queryParams.brandId"
                        @change="onChangeBrand(queryParams.brandId)"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in brandList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="系列：" prop="brandSid">
                      <el-select v-model="queryParams.brandSid" placeholder="请选择">
                        <el-option
                          v-for="(item,index) in seriesList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="产品名称：" prop="proName">
                      <el-input v-model.trim="queryParams.proName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="型号：" prop="proModel">
                      <el-input v-model.trim="queryParams.proModel"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="订货号：">
                      <el-input v-model.trim="queryParams.proOrdernum"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="属地：">
                      <el-select v-model="queryParams.proTerritory" clearable placeholder="全部">
                        <el-option
                          v-for="item in productTerritoryList"
                          :key="item.productTerritory"
                          :label="item.title"
                          :value="item.productTerritory"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="是否停产：">
                      <el-radio-group v-model="queryParams.isStop">
                        <el-radio :label="0">是</el-radio>
                        <el-radio :label="1">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-col>
                <!-- <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="质保期：">

                        <el-input
                          style="width:80%;"
                          @input="inputProWarranty"
                          v-model.number="queryParams.proWarranty"
                        ></el-input>
                        <span>天</span>
                    </el-form-item>
                  </el-col>
                </el-col>-->
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="最小单位：" prop="proUnit">
                      <el-select v-model="queryParams.proUnit" placeholder="请选择">
                        <el-option
                          v-for="(item,index) in unitList"
                          :key="index"
                          :label="item.attrName"
                          :value="item.attrName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="10">
                    <el-form-item label="出货单位：" prop="proOutunit">
                      <el-select
                        v-model="queryParams.proOutunit"
                        placeholder="请选择"
                        style="width:100px;"
                        @change="onChangeOutunit"
                      >
                        <el-option value="单件出售">单件出售</el-option>
                        <el-option value="套装出售">套装出售</el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" v-show="queryParams.proOutunit==='套装出售'&&queryParams.proUnit">
                    <el-row>
                      <el-col :span="9">
                        <el-input-number
                          type="number"
                          :min="1"
                          style="width:100%;margin-left:2px;margin-top:1px;"
                          :controls="false"
                          :precision="0"
                          v-model.number="queryParams.proOutunitCount"
                          placeholder="数量"
                        ></el-input-number>
                      </el-col>
                      <el-col
                        :span="6"
                        style="font-size:14px;text-align:center;margin-top:3px;"
                      >{{queryParams.proUnit}}/</el-col>
                      <el-col :span="8">
                        <el-input placeholder="单位" @input="proOutunitUnit" v-model.trim="queryParams.proOutunitUnit"></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="产品面价：" prop="proPrice">
                      <el-input-number
                        :precision="2"
                        :min="0.01"
                        style="width:100%;"
                        :controls="false"
                        v-model="queryParams.proPrice"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="20" :style="queryParams.proOutunit ==='套装出售'? 'margin-top:10px;':''">
                <el-col :span="8">
                  <el-col :span="24">
                    <el-form-item label="型号别称：">
                      <el-input v-model="queryParams.proModelnick" :rows="4" type="textarea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>

                <el-col :span="8">
                  <el-col :span="24">
                    <el-form-item label="备注：">
                      <el-input v-model="queryParams.mark" :rows="4" type="textarea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="产品类型：" prop="proType">
                      <el-radio-group v-model="queryParams.proType">
                        <el-radio :label="1">标准产品</el-radio>
                        <el-radio :label="2">组合产品</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <div v-show="queryParams.proType === 2" class="box-table">
                <el-table
                  :data="tableData"
                  tooltip-effect="dark"
                  max-height="378"
                  :header-cell-style="tableHeader"
                  border
                >
                  <el-table-column prop="proModel" label="型号"></el-table-column>
                  <el-table-column prop="proOrdernum" label="订单货号"></el-table-column>
                  <el-table-column label="数量">
                    <template slot-scope="scope">
                      <el-input-number
                        :min="1"
                        :controls="false"
                        :precision="0"
                        v-model="scope.row.needCount"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span class="approval" @click="onDelete(scope.row)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row>
                  <el-col :span="24" style="text-align:right;margin-top:10px;">
                    <el-button type="primary" @click="addProductModel">添加子型号</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-form>
        <div class="parameter">
          <div class="add-title">
            <span class="bold"></span>
            <span class="basic">参数</span>
            <div class="save">
              <el-button v-show="queryParams.pcId" @click="onAddParameter">添加参数</el-button>
            </div>
          </div>
          <div class="add-content">
            <p v-if="parameterList.length<1">暂无参数项</p>
            <el-form v-else label-width="125px" class="demo-form-inline">
              <el-row>
                <el-col :span="8" v-for="(item,index) in parameterList" :key="index">
                  <el-col :span="22">
                    <el-form-item :label="item.label+'：'">
                      <el-select
                        clearable
                        filterable
                        v-model="item.productClassParamvalue"
                        value-key="id"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(itemValue,index) in item.productClassParamvalueList"
                          :key="index"
                          :label="itemValue.pvValue"
                          :value="itemValue"
                        ></el-option>
                        <span class="add-params" @click="onParameterValue(item)">+ 添加参数值</span>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <el-row>
          <el-col :span="24" style="text-align:left;margin-top:20px;">
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-------------- 添加参数 -------------->
    <add-parameter-dialog @onRefresh="getQueryProductParam" ref="addParameterDialogRefs"></add-parameter-dialog>
    <!-------------- 添加子型号 -------------->
    <add-model-dialog @onRefresh="getSelectList" ref="addModelDialogRefs"></add-model-dialog>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>

<script>
import addParameterDialog from '../dialog/addParameter'
import OpenOrClose from '@/components/OpenOrClose/index' // 二次确认
import addModelDialog from '../dialog/addModel'
import {
  queryProductParam,
  querySeriesByBrandId,
  addProduct
} from '@/api/product/productManage'
import { deepClone } from '@/util'
import { productAddOrEditRules } from '../utils/formRules'
export default {
  components: {
    'open-or-close-dialog': OpenOrClose,
    'add-parameter-dialog': addParameterDialog,
    'add-model-dialog': addModelDialog
  },
  data () {
    return {
      title: '',
      content: '',
      proClassList: [], // 品类
      queryParams: {
        isStop: 1,
        proType: 1,
        brandId: undefined,
        brandSid: undefined,
        pcbIds: []
      }, // 表单数据
      parameterList: [{ productClassParamvalue: undefined }], // 参数列表
      brandList: [], // 品牌列表
      seriesList: [], // 系列列表
      unitList: [], // 最小单位
      tableData: [], // 表格数据
      // 产品属地
      productTerritoryList: [
        { productTerritory: '国产', title: '国产' },
        { productTerritory: '进口', title: '进口' },
        { productTerritory: '未知', title: '未知' }
      ],
      // 校验
      queryParamsRules: productAddOrEditRules
    }
  },
  mounted () {
    this.parameterList = []
    if (this.$route.query.proId !== undefined) {
      this.getList()
    }
    this.getProductClass() // 品类初始化
    this.getBrandForSelect() // 品牌初始化
    this.getQueryByClassCode() // 最小单位初始化
  },
  methods: {
    // 质保期input
    inputProWarranty () {
      if (
        isNaN(this.queryParams.proWarranty) ||
        this.queryParams.proWarranty === ''
      ) {
        this.queryParams.proWarranty = 0
      } else {
        if (parseFloat(this.queryParams.proWarranty) <= 0) {
          this.queryParams.proWarranty = -parseFloat(
            this.queryParams.proWarranty
          )
        } else {
          this.queryParams.proWarranty = parseFloat(
            this.queryParams.proWarranty
          )
        }
      }
    },
    getList () { },
    // 查看产品分类信息
    async getProductClass () {
      this.proClassList = await this.$queryAllProductClassForCascader()
    },
    // 选择品类获取的
    handleChange (value) {
      if (value.length < 3) {
        this.$message.error('仅支持选择3级分类;')
        this.queryParams.pcId = []
      } else {
        const pcId = value[value.length - 1] // 获取品类最后一级的id
        this.getQueryProductParam(pcId) // 获取品类下所有的参数清单
      }
    },
    proOutunitUnit() {
      if (!this.queryParams.proOutunitUnit) return
      if (!isNaN(Number(this.queryParams.proOutunitUnit))) {
        this.$message.error('单位不能为数字')
        this.queryParams.proOutunitUnit = ''
      }
    },
    // 参数列表
    getQueryProductParam (id, obj, type) {
      const params = deepClone(this.parameterList)
      if (type === 1) {
        queryProductParam(id)
          .then((res) => {
            if (res.data.code === 200) {
              this.parameterList = res.data.obj
              params.forEach((element) => {
                this.parameterList.forEach((ele) => {
                  if (element.id === ele.id) {
                    if (element.productClassParamvalue !== undefined) {
                      ele.productClassParamvalue =
                        element.productClassParamvalue
                    }
                  }
                })
                this.parameterList[
                  this.parameterList.length - 1
                ].productClassParamvalue = obj.productClassParamvalue
                this.parameterList = deepClone(this.parameterList)
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        queryProductParam(id)
          .then((res) => {
            if (res.data.code === 200) {
              this.parameterList = res.data.obj

              params.forEach((element) => {
                this.parameterList.forEach((ele) => {
                  if (element.id === ele.id) {
                    if (element.productClassParamvalue !== undefined) {
                      ele.productClassParamvalue =
                        element.productClassParamvalue
                    }
                  }
                  if (obj.ppId === ele.id) {
                    ele.productClassParamvalue = obj
                  }
                })
              })
              this.parameterList = deepClone(this.parameterList)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 添加参数
    onAddParameter () {
      const pcId = this.queryParams.pcId[this.queryParams.pcId.length - 1]
      this.$refs.addParameterDialogRefs.onInitialize(1, pcId)
    },
    // 添加参数值
    onParameterValue (item) {
      const pcId = this.queryParams.pcId[this.queryParams.pcId.length - 1]
      this.$refs.addParameterDialogRefs.onInitialize(2, item, pcId)
    },
    // 获取所有品牌名称
    async getBrandForSelect () {
      this.brandList = await this.$queryAllBrandForSelect()
      if (this.$route.query.brandId !== undefined) {
        this.queryParams.brandId = +this.$route.query.brandId
        this.onChangeBrand(this.queryParams.brandId, false)
      }
    },
    // 根据品牌id获取系列
    onChangeBrand (id, val) {
      this.queryParams.brandSid = undefined
      querySeriesByBrandId(id)
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.code === 200) {
              this.seriesList = res.data.obj
              if (val === false) {
                this.queryParams.brandSid = +this.$route.query.seriesId
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 根据多个分类类型显示属性内容
    async getQueryByClassCode () {
      const params = await this.$queryByClassCode()
      try {
        this.unitList = params.unitList
      } catch (e) {
        console.log(e)
      }
    },
    // 判断套装出售时是否有最小单位
    onChangeOutunit () {
      if (this.queryParams.proOutunit === '套装出售') {
        if (!this.queryParams.proUnit) {
          this.$message.error('请先选择最小单位！')
        }
      }
    },
    // 显示添加型号弹框
    addProductModel () {
      this.$refs.addModelDialogRefs.onInitialize()
    },
    // 获取子型号
    getSelectList (list) {
      const dataList = deepClone(list)
      const tableDataList = deepClone(this.tableData)
      dataList.forEach((element, index) => {
        let isFalse = false
        tableDataList.forEach((ele) => {
          if (ele.proCbid === element.id) {
            isFalse = true
          }
        })
        if (!isFalse) {
          const params = {
            id: 0,
            needCount: 1,
            proBid: 0,
            proCbid: element.id,
            proModel: element.productModel,
            proName: element.productName,
            proOrdernum: element.productOrderNum,
            serial: index
          }
          this.tableData.push(params)
        }
      })
    },
    onUpdataState () { },
    // 删除子型号
    onDelete (row) {
      const index = this.tableData.indexOf(row)
      this.tableData.splice(index, 1)
    },
    // 设置头部颜色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 提交并上线
    onSubmit () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) {
          if (Array.isArray(this.queryParams.pcId)) {
            // 判断品类是否有值,有值的话再进行赋值
            this.queryParams.pcId = this.queryParams.pcId[
              this.queryParams.pcId.length - 1
            ] // 获取最后一级id
          }
          const list = []
          this.parameterList.forEach((item) => {
            if (item.productClassParamvalue) {
              const paramsList = {
                pcpId: item.id,
                pcpmId: item.productClassParamvalue.id,
                pcpmValue: item.productClassParamvalue.pvValue
              }
              list.push(paramsList)
            }
          })
          const params = {
            isFormalProduct: true,
            productBase: this.queryParams, // 基本信息
            productBomVoList: this.tableData, // 子型号
            productParamContentList: list // 参数
          }
          if (
            params.productBase.proType === 2 &&
            params.productBomVoList.length === 0
          ) {
            this.$message.error('组合产品请至少绑定一个子型号')
          } else if (
            this.queryParams.proOutunit === '套装出售' && (!this.queryParams.proOutunitCount || !this.queryParams.proOutunitUnit)
          ) {
            this.$message.error('请选择套装出售数量并填写单位！')
          } else {
            addProduct(params)
              .then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('添加成功')
                  this.$router.push({
                    name: 'productList',
                    query: { goTo: this.$route.query.name }
                  })
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    }
  }
}
</script>
<style >
.add-params {
  padding-left: 20px;
  font-size: 14px;
  color: #276cff;
  cursor: pointer;
  line-height: 30px;
  height: 30px;
}
</style>
